
const digest = '9f6c598774ed933dc12002c096b75235e6881ee38a589288c29d3562a11add7c';
const classes = {"container":"_container_x2nn0_1","componentStep":"_componentStep_x2nn0_10"};
const css = `._container_x2nn0_1 {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  overflow-y: hidden;
}

._componentStep_x2nn0_10 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  overflow-y: hidden;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  